<template>
  <div class="bbe-folders-tree">
    <transition name="bbe-fade" appear>
      <loader-fly v-if="loaderRun"/>
    </transition>
    <VuePerfectScrollbar class="bbe-folders-tree-body">
      <FoldersTreeElem class="bbe-folders-tree-body-folder"
                       :key="'template'"
                       :selected-folder="selectedFolder"
                       :depth="0"
                       :home="true"
                       :folder="{id: '', name: 'Templates'}"
                       @setFolder="setFolder"
                       @setLoader="setLoader"/>
      <FoldersTreeElem class="bbe-folders-tree-body-folder"
                       v-for="folder in foldersList"
                       :key="folder.id"
                       :selected-folder="selectedFolder"
                       :depth="1"
                       :folder="folder"
                       @setFolder="setFolder"
                       @setLoader="setLoader"/>
    </VuePerfectScrollbar>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import foldersApi from '@/api/Folders/api'
import LoaderFly from '@/components/Main/Loaders/LoaderFly'
import FoldersTreeElem from '@/components/Templates/FoldersTree/FoldersTreeElem'

export default {
  name: 'FoldersTree',
  components: {
    FoldersTreeElem,
    VuePerfectScrollbar,
    LoaderFly
  },
  data () {
    return {
      foldersList: [],
      selectedFolder: {},
      loaderRun: false
    }
  },
  methods: {
    setFolder (folder) {
      const isAlreadySelected = this.selectedFolder.id === folder.id
      this.selectedFolder = isAlreadySelected ? {} : folder
      this.$emit('setFolder', folder)
    },
    setLoader (value) {
      this.loaderRun = value
    },
    getFolders () {
      this.loaderRun = true
      foldersApi.getFolder({})
        .then(resp => {
          this.foldersList = resp.data.folders
          this.loaderRun = false
        })
        .catch(err => {
          this.loaderRun = false
          console.error(err)
        })
    }
  },
  beforeMount () {
    this.setFolder({id: '', name: 'Templates'})
    this.getFolders()
  }
}
</script>

<style lang="scss" scoped>
@import "../../../sass/variables";
@import "../../../sass/mixins";

.bbe-folders-tree {
  border: 1px solid $color-gallery;
  box-sizing: border-box;
  border-radius: 5px;

  &-body {
    padding: 3px 0;
    width: 444px;
    height: 309px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Templates/FoldersTree/FoldersTree.vue